import React, { useContext } from 'react';
import { Formik, Form, useFormikContext } from 'formik';
import * as Yup from 'yup';
import { Button } from 'primereact/button';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import AbilityData from './AbilityData';
import { AccountContext } from '../../../components/AccountContext';

const AddAbility = () => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const {
    setFieldValue,
    values: { ability },
  } = useFormikContext();

  const initialValues = {
    code: ability.code ? ability.code : '',
    displayName: ability.displayName ? ability.displayName : '',
    description: ability.description ? ability.description : '',
  };

  const validationSchema = Yup.object({
    code: Yup.string().required(),
    displayName: Yup.string().required(),
    description: Yup.string().required(),
  });

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikBag) => {
        formikBag.resetForm();

        setFieldValue('ability', { ...values });

        history.push(`/accounts/${currentAccount}/add-itembank-survey-content/new/add-survey-items`);
      }}
      render={({ handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <AbilityData />
          <div>
            <FormattedMessage id="actions.save" defaultMessage="Save">
              {(text) => <Button type="submit" label={text} />}
            </FormattedMessage>
            <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
              {(text) => (
                <Button type="button" onClick={() => history.goBack()} className="p-button-secondary" label={text} />
              )}
            </FormattedMessage>
          </div>
        </Form>
      )}
    />
  );
};

AddAbility.propTypes = {
  currentAccount: PropTypes.string.isRequired,
};

export default AddAbility;
